import { motion } from "framer-motion";
import { MoveDown, MoveRight } from "lucide-react";
import { FadeUp, Chapter, EASE } from "@/components/Reveal";
import { PROCESS } from "@/data/content";

export default function Process() {
  return (
    <section
      data-testid="process-section"
      className="border-t border-white/5 py-28 lg:py-36"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Chapter num="04" label="Process" />
        <FadeUp delay={0.1}>
          <h2 className="mt-8 max-w-xl font-serif text-4xl leading-tight tracking-[-0.02em] text-cream sm:text-5xl">
            A Clear Path From First Call to{" "}
            <span className="italic text-gold">Real Growth.</span>
          </h2>
        </FadeUp>

        <div className="relative mt-20 grid grid-cols-1 gap-14 lg:grid-cols-4 lg:gap-8">
          <div className="absolute left-0 right-0 top-6 hidden h-px bg-gradient-to-r from-gold/40 via-white/10 to-gold/40 lg:block" />
          {PROCESS.map((p, i) => (
            <motion.div
              key={p.num}
              data-testid={`process-step-${p.num}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.15, ease: EASE }}
              className="relative"
            >
              <div className="flex items-center gap-4">
                <span className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full border border-gold/50 bg-noir font-serif text-lg text-gold">
                  {p.num}
                </span>
                {i < PROCESS.length - 1 && (
                  <>
                    <MoveRight className="hidden h-5 w-5 text-gold/40 lg:block" />
                    <MoveDown className="h-5 w-5 text-gold/40 lg:hidden" />
                  </>
                )}
              </div>
              <h3 className="mt-6 font-serif text-2xl text-cream">{p.title}</h3>
              <p className="mt-2 max-w-[240px] text-sm leading-relaxed text-cream/50">
                {p.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
